export default {
  de: {
    themenTitel: 'Themen',
    ethnografienTitel: 'Ethnografien',
    pdfDownloadText: 'Publikation als PDF zum Download',
    mehrButton: 'mehr ...',
    vorButton: 'vor',
    zurückButton: 'zurück',
    videoDisplaySwitch: {
      low: 'schnell',
      high: 'hochauflösend',
      lable: 'Qualität'
    },
    kssTitel: 'Kulturstiftung Sibirien',
    partnerTitel: 'Partner',
    relatedVideos: 'Videos zu diesem Thema',
    videos: 'Videos',
    videosOn: 'Videos zu den Themen',
    showMoreVideos: 'Mehr Videos anzeigen',
    ethnographica: 'Ethnographica',
    ethnographicaOn: 'Ethnographica zu den Themen',
    showMoreEthnographica: 'Weitere Ethnographica anzeigen',
    fotos: 'Fotos',
    fotosOn: 'Fotos zu den Themen',
    showMoreFotos: 'Weitere Fotos anzeigen',
    books: 'Bücher',
    booksOn: 'Bücher zu den Themen',
    showMoreBooks: 'Weitere Bücher anzeigen',
    autographs: 'Autographen',
    autographsOn: 'Autographen zu den Themen',
    showMoreAutographs: 'Weitere Autographen anzeigen',
    digLibs: 'Digitale Bibliothek',
    digLibsOn: 'Bestände zu den Themen',
    showMoreDigLibs: 'Weitere Objekte anzeigen',
    readDocument: 'Dokument lesen ...',
    dossiers: 'Dossiers',
    dossiersOn: 'Dossiers zu den Themen'
  },
  en: {
    themenTitel: 'Themes',
    ethnografienTitel: 'Ethnographies',
    pdfDownloadText: 'Publication as PDF for Download',
    mehrButton: 'more ...',
    vorButton: 'next',
    zurückButton: 'previous',
    videoDisplaySwitch: {
      low: 'fast',
      high: 'high resolution',
      lable: 'Quality'
    },
    kssTitel: 'Kulturstiftung Sibirien',
    partnerTitel: 'Partner',
    relatedVideos: 'Related Videos',
    videos: 'Videos',
    videosOn: 'Videos about',
    showMoreVideos: 'Show more videos',
    ethnographica: 'Ethnographica',
    ethnographicaOn: 'Ethnographica on',
    showMoreEthnographica: 'Show more ethnographica',
    fotos: 'Fotos',
    fotosOn: 'Fotos on',
    showMoreFotos: 'Show more fotos',
    books: 'Books',
    booksOn: 'Books on',
    showMoreBooks: 'Show more books',
    autographs: 'Autographs',
    autographsOn: 'Autographs on',
    showMoreAutographs: 'Show more autographs',
    digLibs: 'DigitalLibrary',
    digLibsOn: 'Items on',
    showMoreDigLibs: 'Show more items',
    readDocument: 'Read document ...',
    dossiers: 'Dossiers',
    dossiersOn: 'Dossiers on'

  },
  ru: {
    themenTitel: 'Темы',
    ethnografienTitel: 'Этнографии',
    pdfDownloadText: 'Публикация в формате PDF для загрузки',
    mehrButton: 'подобнее ...',
    vorButton: 'следующий',
    zurückButton: 'прежний',
    videoDisplaySwitch: {
      low: 'скорый',
      high: 'высокое разрешение',
      lable: 'особенность'
    },
    kssTitel: 'Фонд культуры народов Сибири',
    partnerTitel: 'Партнёры',
    relatedVideos: 'соответствующие видеофильмы',
    videos: 'видео',
    videosOn: 'видео про',
    showMoreVideos: 'показать больше видео',
    ethnographica: 'Этнографические предметы',
    ethnographicaOn: 'другие этнографические предметы',
    showMoreEthnographica: 'дополнительные этнографические предметы',
    fotos: 'Фото',
    fotosOn: 'Fotos on',
    showMoreFotos: 'Show more fotos',
    books: 'Книги',
    booksOn: 'Books on',
    showMoreBooks: 'Show more books',
    autographs: 'Автограф',
    autographsOn: 'Autographs on',
    showMoreAutographs: 'Show more autographs',
    digLibs: 'Электронная библиотека',
    digLibsOn: 'Items on',
    showMoreDigLibs: 'Показать другие объекты',
    readDocument: 'Читать документ ...',
    dossiers: 'Досье',
    dossiersOn: 'Dossiers on'
  }
}
